import _ from 'lodash';
import React, { useState, useCallback } from 'react';
import {useHistory} from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import { SubmissionGrid } from './submission-grid';
import SubmissionFormView from './submission-form-view';
import { toast } from 'react-toastify';


const Submissions = ({artistStore, genreStore}) => {
	const history = useHistory();
	const onSelectionChange = useCallback(({selected}) => {
		//Navigate to the form for that artist
		setActiveArtist(selected);
		setViewingArtist(true);
	}, [])
	const [activateRowOnFocus, setActivateRowOnFocus] = useState(true);
	const [viewingArtist, setViewingArtist] = useState(false);
	const [activeArtist, setActiveArtist] = useState(null);

	const submitArtist = async (artist) => {
		artist.tier = 'Tier 1';
		await artistStore.saveArtist({
			...artist,
		});
		setViewingArtist(false);
		setActiveArtist(null);
	}

	const cancelViewArtist = useCallback(() => {
		setViewingArtist(false);
		setActiveArtist(null);
	}, []);

	artistStore.setStatusFilter('ALL');
	artistStore.setTierFilter('IN_REVIEW');
	const artistData = artistStore.filteredArtistList.map(item => {
		return {
			_id: item._id,
			name: item.name,
			email: item.user.userName,
			status: item.status,
			genre: genreStore.getLabel(item.genreId), // new genre label field makes accessing genres a easier
			createdAt: item.createdAt,
			catalogSize: item.songs.length,
			searchStatus: item.searchStatus
	}})

	return (
    <div>
		<div className="grid-x padding-top-1 padding-left-1">
			<div className="cell auto">
				<h3 data-ta="submissionsHeader">New Artist Submissions</h3>
			</div>
		</div>

		{(viewingArtist) ? <SubmissionFormView artist={activeArtist} onCancel={cancelViewArtist} onComplete={() => {submitArtist(activeArtist);}}/> :
		<SubmissionGrid dataSource={artistData} onRowClick={(rowData) => onSelectionChange({selected: rowData})} />}
    </div>
  );
}

const injectWithStores = inject('artistStore', 'genreStore');
export default injectWithStores(
	({artistStore, genreStore}) => {
		return (
			<Submissions artistStore={artistStore} genreStore={genreStore} />
		)
})
